import { ROUTES } from '@/router/routesEnum';
import axios from 'axios';
import { msalInstance } from 'vue-msal-browser';
import router from '../../router';
import store from '../store';
import { loginApiRequest } from '../utils/authConfig';
import LSService from './LocalStorageService';
const lsService = LSService.getService();

export const instance = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_API_URL,
});

export enum URLS {
  authenticate = '/api/Users/login2',
  account = '/api/Users',
  entraJobs = '/api/entraJobs',
  entraJobsnOdata = '/odata/entraJobs',

  // Some URLs not work without `*Odata` (any distinct word), so `/odata/companys` return backend error `Resource is NULL` don't sure why but this fix helps
  companyOdata = '/odata/companysOdata',
  company = '/api/companys',
  conditionCategoryOdata = '/odata/conditionCategorys',
  conditionCategory = '/api/conditionCategorys',
  contactOdata = '/odata/contacts',
  contact = '/api/contacts',
  contactPanelOdata = '/odata/contactPanels',
  contactPanel = '/api/contactPanels',

  documentTypeOdata = '/odata/documentTypes',
  documentType = '/api/documentTypes',

  gspRoleOdata = '/odata/gspRolesOdata',
  gspRole = '/api/gspRoles',
  gspRoleDataOdata = '/odata/gspRolesDataOdata',
  gspRoleData = '/api/gspRolesData',
  gspUserRoleOdata = '/odata/gspUserRolesOdata',
  gspUserRole = '/api/gspUserRoles',
  gspUserRoleDetailOdata = '/odata/gspUserRoleDetails',
  gspUserRoleDetail = '/api/gspUserRoleDetails',

  gspAttributeOdata = '/odata/gspAttributesOdata',
  gspAttribute = '/api/gspAttributes',
  gspModuleOdata = '/odata/gspModulesOdata',
  gspModule = '/api/gspModules',
  gspServiceOdata = '/odata/gspServicesOdata',
  gspService = '/api/gspServices',

  admpNewsOdata = '/odata/admpNews',
  admpNews = '/api/AdmpNews',

  tblUpdateSupplierOdata = '/odata/tblUpdateSuppliers',
  tblUpdateSupplier = '/api/tblUpdateSuppliers',

  tblUpdateConditionOdata = '/odata/tblUpdateConditions',
  tblUpdateCondition = '/api/tblUpdateConditions',

  tblUpdateDocumentOdata = '/odata/tblUpdateDocuments',
  tblUpdateDocument = '/api/tblUpdateDocuments',

  tblUpdateScprixFileOdata = '/odata/tblUpdateScprixFiles',
  tblUpdateScprixFile = '/api/tblUpdateScprixFiles',

  tblUpdateGPSRProdVOFileOdata = '/odata/tblUpdateGPSRProdVOFiles',
  tblUpdateGPSRProdVOFile = '/api/tblUpdateGPSRProdVOFiles',

  tblUpdateNewsOdata = '/odata/tblUpdateNews',
  tblUpdateNews = '/api/tblUpdateNews',

  tblKollegenauslieferungOdata = '/odata/tblKollegenauslieferungs',
  tblKollegenauslieferung = '/api/tblKollegenauslieferungs',

  tblLieferantenOdata = '/odata/tblLieferantens',
  tblLieferanten = '/api/tblLieferantens',

  tblMitgliederOdata = '/odata/tblMitglieders',
  tblMitglieder = '/api/tblMitglieders',

  // TODO(ad-105) fix console error no need for this in frontend
  userActionsUserRoleChangesOdata = '/odata/UserActionsUserRoleChanges',
  userActionsUserRoleChanges = '/api/UserActionsUserRoleChanges',

  users = 'api/users',
  usersOdata = 'odata/users',
  version = 'api/version', // for test

  msGraphUsers = 'https://graph.microsoft.com/v1.0/users',
}

// Need to ignore MSAL azure token for using these URLs in 3rd-party sites via `iframe`
const routesNoToken = [
  'GetVmeStatisticsData',
  'GetVmeSupplier',
  'GetVmeImageByLink',
  'GetVmeUserIdByEmail',
  'GetCompaniesIframe',
  'GetWarengruppenList',
  'GetEnvironmentName',
];
// (AD-161) new routes
routesNoToken.push(
  'odata/tblUpdateSuppliers',
  'odata/tblUpdateConditions',
  'odata/tblUpdateDocuments',
  'odata/tblUpdateNews',
  'odata/tblUpdateScprixFiles',
  '/odata/tblUpdateGPSRProdVOFiles',
  'companys/getUserCompanyZr',
  'GetCompanyWrGruppen',
  'GetConditionsVisible',
  'GetLieferantengruppen',
  'GetLieferantengruppenFilter',
  'GetSuppliersCompanyWrGruppen',
  'GetBereichList',
  'GetCategoryList',
  'GetAuthorList',
  'GetCountTopNews',
  'GetCountUpdateRecors'
);
routesNoToken.push(
  '/api/tblUpdateConditions/AddConditionCompleted',
  '/api/tblUpdateConditions/GetUpdateConditionLieferantGr',
  '/api/tblUpdateConditions/GetUpdateConditionHauptWrGr',
  '/api/tblUpdateConditions/GetCountUpdateRecords',
  '/api/tblUpdateDocuments/AddDocumentCompleted',
  '/api/tblUpdateDocuments/getDocumentCategoryList',
  '/api/tblUpdateSuppliers/AddSupplierCompleted',
  '/api/tblUpdateNews/AddNewsCompleted',
  '/api/tblUpdateScprixFiles/AddScprixFileCompleted',
  '/api/tblUpdateScprixFiles/CanselScprixFileCompleted',
  '/api/tblUpdateScprixFiles/DownloadFile',
  '/api/tblUpdateGPSRProdVOFiles/AddGPSRProdVOFileCompleted',
  '/api/tblUpdateGPSRProdVOFiles/CanselGPSRProdVOFileCompleted',
  '/api/tblUpdateGPSRProdVOFiles/GetZRNummerList',
  '/api/tblUpdateGPSRProdVOFiles/DownloadFile',
  '/api/tblUpdateGPSRProdVOFiles/DownloadArtusFile',
  '/api/tblUpdateGPSRProdVOFiles/GetGPSRProdVOExcelReport',
  '/api/tblLieferantens/GetLieferantengDataReport',
  'CanselConditionCompleted',
  'CanselDocumentCompleted',
  'CanselSupplierCompleted',
  'CanselNewsCompleted',
  'CanselScprixFileCompleted'
);
routesNoToken.push(
  'odata/tblKollegenauslieferungs',
  '/api/tblKollegenauslieferungs/GetZrNumberList',
  '/api/tblKollegenauslieferungs/GetSearchResult',
  '/api/tblKollegenauslieferungs/GetVMEHauptwarengruppenList',
  'odata/tblLieferantens',
  '/api/tblLieferantens/GetSearchResult',
  '/api/tblLieferantens/GetZrNumberList',
  '/api/tblLieferantens/GetHauptwarengruppenList',
  '/api/tblLieferantens/GetStatusCompaniesList',
  '/api/tblLieferantens/GetLieferantenExcelReport',
  '/api/tblLieferantens/CreateLieferantenFileLogRecord',
  '/api/tblLieferantens/GetLieferantengDataReport',
  'odata/tblMitglieders',
  '/api/tblMitglieders/GetSearchResult',
  '/api/tblMitglieders/GetZrNumberList',
  '/api/tblMitglieders/GetStatusCompaniesList',
  '/api/tblMitglieders/GetListMitgliederGebietPLZ',
  '/api/users/LogFormActions',
  'odata/EntraJobs',
  '/api/entraJobs/GetJobsNameList',
  '/api/entraJobs/GetEntityList',
  '/api/entraJobs/GetListAction',
  '/api/entraJobs/GetSearchResult',
  '/api/entraJobs/GetAllEntraJobs',
  '/api/entraJobs/UpdateEntraJobInterval'
);

instance.interceptors.request.use(
  async (config: any) => {
    try {
      console.log('config :>> ', config);
      // not get token only for `GetVmeSupplier` and `GetVmeUserIdByEmail` endpoints
      const url = (config?.url + '').toLowerCase();
      // url?.includes('GetVmeSupplier') || url?.includes('GetVmeUserIdByEmail')
      if (routesNoToken.some((route) => url.includes(route.toLowerCase()))) {
        config.headers['Content-Type'] = 'application/json';
        // console.log('config?.url config?.url:>> NO TOKIN NOT TOKEN ', config?.url);
        return config;
      }

      console.log('try to send interceptors:>> ');
      // console.log('config interceptors.request.use :>> ', config);
      let account = msalInstance!.getAllAccounts()?.[0]; //.getAllAccounts()[0];
      // const account2 = msalInstance!.getAllAccounts(); //.getAllAccounts()[0];
      // console.log('account dd:>> ', account );
      // console.log('account dd:>> ', account2 );
      // console.log('msalInstance :>> ', msalInstance);
      if (!account) {
        account = await waitForMsalAccount(2500); // 2.5 second timeout
      }

      if (account) {
        return await setupConfigWithToken(account, config);
      }
      console.warn('No MSAL account found, sending request without token. URL:>> ', config?.url);
      config.headers['Content-Type'] = 'application/json';
      return config;
    } catch (error) {
      // https://github.com/svrcekmichal/redux-axios-middleware/issues/83
      console.error('backend index Error, config URLll:>> ', config?.url);
      console.error(error);
      return Promise.reject(error); // (AD-0) added `Promise.reject` to fix `undefined` error for `cancelToken` in `axios` when request interceptor throws error
    }
  },
  (error: any) => {
    // store.dispatch(`${URLS.users}/logout`);
    // router.push({
    //   name: ROUTES.login,
    //   params: { checkLogin: 'false' },
    // });
    return Promise.reject(error); // (AD-0) added `Promise.reject` to fix `undefined` error for `cancelToken` in `axios` when request interceptor throws error
  }
);

// Helper function to wait for MSAL account
function waitForMsalAccount(timeoutMs: number): Promise<any> {
  return new Promise((resolve, reject) => {
    const startTime = Date.now();

    const checkAccount = () => {
      const account = msalInstance?.getAllAccounts()?.[0];
      if (account) {
        resolve(account);
      } else if (Date.now() - startTime >= timeoutMs) {
        resolve(null); // Timeout reached, return null
      }
      // No account yet, but still time left, check again soon every 500ms
      else {
        setTimeout(checkAccount, 500);
      }
    };

    checkAccount();
  });
}

async function setupConfigWithToken(account: any, config: any) {
  const msalResponse = await msalInstance?.acquireTokenSilent({
    ...loginApiRequest,
    account: account,
  });
  const tokenMsGraphApi = await msalInstance!.acquireTokenSilent({
    scopes: ['https://graph.microsoft.com/User.Read'],
    account: account,
  });
  // const token = lsService.getAccessToken(); // don't need it for AZURE_AD // TODO: find a way to distinguish between Azure and usual login if needed or remove usual `login/pass` logic
  if (msalResponse && msalResponse.accessToken) {
    config.headers['Authorization'] = 'Bearer ' + msalResponse!.accessToken;
  }
  if (config.url.includes('graph.microsoft.com/v1.0')) {
    config.headers['Authorization'] = 'Bearer ' + tokenMsGraphApi.accessToken;
    config.headers['ConsistencyLevel'] = 'eventual'; // needed for OData `$search` query operator
  }
  config.headers['Content-Type'] = 'application/json';
  return config;
}

instance.interceptors.response.use(
  (response: any) => {
    // console.log('window.location.pathName RESPONSE :>> ', window.location.pathname);

    return response;
  },
  (error: any) => {
    const originalRequest = error.config;
    const refreshToken = lsService.getRefreshToken();
    if (error.response?.status === 401 && !originalRequest._retry && refreshToken) {
      originalRequest._retry = true;

      const token = lsService.getAccessToken();
      return axios
        .post(
          `${URLS.users}/refreshtoken`,
          {
            refreshToken: refreshToken,
            accessToken: token,
          },
          {
            headers: {
              'Content-Type': 'application/json', // TODO: test if need this header (backend was set up to use JSON) + the same for `checkPasswordReset` action
            },
          }
        )
        .then((res: any) => {
          if (res?.status === 201 || res?.status == 200) {
            lsService.setToken(res.data);
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + lsService.getAccessToken();
            return axios(originalRequest);
          }

          return Promise.reject(error);
        });
    } else if (error.response?.status === 401) {
      // NO refresh Token (not checked `Remember me` on Login) and JWT token expired

      store.commit('auth/resetAccount', undefined); // (EGRUP-270) need this reset to make `isLoggedIn` getter FALSE, otherwise we will see left drawer menu with icons and Username in top left corner
      // router.push({
      //   name: ROUTES.login,
      //   params: { checkLogin: 'false' },
      // });
      // tried to show `'Der Token ist abgelaufen. Bitte erneut anmelden',` snackbar but it always overriden by `"Laden der Daten fehlgeschlagen` red snackbar from `action.ts`
    }
    throw error;
  }
);
